import React, { PropTypes, Component } from 'react'
import styles from '../styles'
import CellDiv from './cellDiv'
import misc from 'utils/misc'

export default class InputCell extends Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  constructor (props) {
    super(props)
    this.onChange = (e) => {
      this.props.onChange(props.dataKey, e.target.value)
    }
  }

  shouldComponentUpdate (nextProps) {
    // you need to avoid update by passing same items object to it
    const compareKeys = ['value', 'width']
    return !misc.isObjectEqual(this.props, nextProps, compareKeys)
  }

  render () {
    const { value } = this.props
    return (
      <CellDiv width={this.props.width} className={styles.inputCell}>
        <input value={value} onChange={this.onChange} />
      </CellDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataCell/inputCell.jsx